import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export interface PrincipleCardProps {
  title: string
  description: any
  icon: IconName
  iconPrefix: IconPrefix
}

export const usePrincipleCard = (props: PrincipleCardProps) => {
  return {
    ...props,
  }
}
